<button
  [disabled]="disabled"
  (click)="onClick($event)"
  class="progress-button btn-default btn-green-dark w-100 h-100"
  #progressShape
>
  <div class="progress-bar" #progressBar></div>
  <div
    class="progress-content d-flex align-items-center justify-content-center"
  >
    <ng-content></ng-content>
  </div>
</button>
